<template>
    <div id="app">
        <div class="warp">
            <div class="head_warps" :style="{height:wheight+'rem'}">
                <!-- <img :src="require('../static/images/head_img.png')" class="head_img" :style="{height:imgheight}"> -->
                <img :src="headmsg.memberBackgroundImg" class="head_img" :style="{height:imgheight}">  
                <!-- <span class="follow">+关注</span> -->
                <div class="head_wrap" :style="{top:top+'rem'}">
                    <div class="Head_portrait" :style="{width:width+'rem',height:height+'rem',border:border+'rem solid #fff'}">
                        <img :src="headmsg.memberSmallImg||require('../static/images/share_1.png')" class="">
                    </div>
                </div>
                 <transition name="fade">
                    <div class="introduce" v-if="show">
                        <span class="name">{{headmsg.memberPetName||'比笔'}}</span>
                        <p>{{headmsg.signInfo||'暂未留下签名'}}</p>
                        <div>
                            <span class="follow_num">关注{{headmsg.myFollowCount||'0'}}</span>
                            <span class="line"></span>
                            <span class="fans_num">粉丝{{headmsg.fansCount||'0'}}</span>
                        </div>
                    </div>
                 </transition>
            </div>
            <div class="main_all">全部文章 {{headmsg.memberInfoCount||'0'}}</div>
        </div>
        <div class="main" :style="{top:mtop+'rem'}">
            <div ref="main" id="main" >
                <div  v-for="list in listmsg" :key="list.hits"  :customInfoId="list.customInfoId">
                    <List :listmsg="list"></List>
                </div>
            </div>
            <infinite-loading :on-infinite="onInfinite" ref="infiniteLoading" spinner="bubbles"> <span slot="no-more">没有更多内容啦</span>   </infinite-loading> 
       </div>
    </div>
</template>
<script>
// import webCoobyApp from "./js/coobyApp.js";
import webCoobyApp from "../static/js/coobyApp";
 import axios from 'axios';
import List from "./components/List.vue";
import jQuery from "../static/js/jquery-1.8.3";
import "../static/css/base2.0.css"
import InfiniteLoading from 'vue-infinite-loading';
axios.defaults.baseURL = '';
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
export default {
    name: 'app',
    data() {
        return {
            headmsg: {},
            listmsg:[],
            list: [],
            widths: 0,
            width: 1,
            imgheight:'100%',
            height: 1,
            top: 0.84,
            border: 0.05,
            iheight: 1.8,
            wheight: 3.8,
            mtop: 4.6,
            show:true,
            lastid:'',
            scroll: '',
            memberId:''
        }
    },
    created() {
         this.getSlider();
        //  console.log(webCoobyApp);
     },
    methods: {
        move() {
        },
        getSlider() {//head部分
                let that = this;
                axios.get('/webapi/member_getMemberInfoPageDetail.do',{
                     params: {
                        memberId:this.$route.query.memberId
                     }
                }).then(function(res) {
                    //  console.log(res.data)
                    if(res.data.code==='200'){
                        let datas = res.data.data;
                        that.headmsg=datas;
                        //设置微信的分享信息
                        let shareInfo = {
                            title: that.headmsg.shareTitle,
                            imgUrl: that.headmsg.memberSmallImg,
                            desc: that.headmsg.shareDescribe
                        };
                        webCoobyApp.weixinUtil.setShareParam(shareInfo);
                        that.setPageTitle();
                    }else{
                        alert("数据返回异常")
                    }
                    
                }).catch(function(err) {
                    console.log("请求头部数据请求失败：" + err);
                })
            },


        onInfinite() {
                let that = this;
                axios.get('/webapi/member_queryListCustominfoByMemberId.do', {
                            params: {
                                 memberId:this.$route.query.memberId,
                                 lastId: this.lastid //这里是分页参数
                            } 
                    }).then((res) => {
                        if(res.data.code==='200'){
                            //  console.log(res.data)
                            if (res.data.data.length) {//获取传过来的list的最后一个customInfoId
                                let app_length = res.data.data.length - 1;//获取索引值
                                this.lastid = res.data.data[app_length].customInfoId;//获取customInfoId
                            }
                            if (res.data.data.length>0) {
                                this.listmsg = this.listmsg.concat(res.data.data);  
                                this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');//这个是渲染
                            }  else {
                                this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');//单页数据全部全部加载
                            }
                        }else{
                        alert("文章列表返回异常")
                        }
                    }).catch(function(err) {
                        console.log("请求失败：" + err);
                        })
                },
                /*↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓2017年11月30日添加的代码，设置文章的title↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓*/
                setPageTitle:function(){
                    var title=document.getElementsByTagName("title")[0];
                    var autorName=this.headmsg.memberPetName;
                    title.innerHTML=autorName;
                },
                /* setShareParam: function (options) {// 设置分享参数
                    if (!this.isWeixinBrowser()) {
                        return;
                    }

                    var jsSdkUrl = "http://res.wx.qq.com/open/js/jweixin-1.0.0.js";
                    if (window.location.protocol == "https:") {
                        jsSdkUrl = "https://res.wx.qq.com/open/js/jweixin-1.0.0.js";
                    }

                    var _this = this;
                    this.loadJs(jsSdkUrl, function () {
                        _this.initConfig(options);
                    });
                }, */
                /* ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑2017年11月30日添加的代码，设置文章的title↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑ */
    },

    components: { List,InfiniteLoading, }
}
</script>

<style>
.warp {
    z-index: 999;
    width: 100%;
}
.head_warps {
    transition: height .3s;
    overflow: hidden;
}
.head_img {
    width: 100%;
     /* height: 100%;  */
    position: relative;
    top: 0;
}
.follow {
    width: .96rem;
    height: .36rem;
    font-size: .26rem;
    line-height: .36rem;
    position: absolute;
    top: .66rem;
    right: .94rem;
    text-align: center;
    color: #fff;
    border: 1px solid #fff;
    border-radius: 2px;
}
.head_wrap {
    width: 100%;
    position: absolute;
    transition: top .2s;
}
.Head_portrait {
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
    box-sizing: content-box;
    margin: auto;
    transition: all .5s;
    border-radius: 50%;
    -ms-box-sizing: content-box;
    -o-box-sizing: content-box;
}
.Head_portrait img {
    display: block;
    width: 100%;
    height: 100%;
        border-radius: 50%;
}
.introduce {
    width: 100%;
    height: 1.8rem;
    position: absolute;
    top: 1.85rem;
}
.introduce span {
    display: block;
    margin-top: .24rem;
    text-align: center;
}
.introduce p {
    width: 100%;
    margin-top: .24rem;
    font-size: .24rem;
    text-align: center;
    color: #fff;
        overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}
.introduce div {
    display: flex;
    width: 3.22rem;
    margin-left: -1.61rem;
    position: absolute;
    left: 50%;
    letter-spacing: 1px;
    justify-content: space-between;
}
.follow_num {
    width: 1.6rem;
    font-size: .26rem;
    text-align: center;
    color: #9fbbcc;
}
.name {
    font-size: .32rem;
    font-weight: bold;
    color: #fff;
}
.line {
    width: 2px;
    height: .24rem;
    margin-bottom: -.24rem;
    margin-left: -.01rem;
    position: absolute;
    bottom: 50%;
    left: 50%;
    background: #9fbbcc;
}
.fans_num {
    width: 1.6rem;
    font-size: .26rem;
    text-align: center;
    color: #9fbbcc;
}
.main {
    width: 100%;
    position: absolute;
    transition: top .7s;
    background: #f1f1f1;
}
.main_all {
    width: 100%;
    height: .8rem;
    font-size: .3rem;
    line-height: .8rem;
    /* position: fixed; */
    position: relative;
    transition: top .2s;
    text-align: center;
    color: #17191a;
    background: #fff;
}
.main_all:after {
    width: .5rem;
    height: .04rem;
    margin-left: -.25rem;
    position: absolute;
    bottom: 0;
    left: 50%;
    content: '';
    background: #ffc840;
}
.infinite-status-prompt{
    display: none;
}
</style>



// WEBPACK FOOTER //
// App.vue?61235d7d